import React from "react";

import SliderMini from "components/Inputs/Slider/SliderMini";

import styles from "./style.module.css";

export default class ChooseProcessLimitFrontier extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { showSlider: true };
  }
  state = {
    showSlider: true
  };

  handleNoConstraints() {
    const { updateProcessLimit, total } = this.props;
    const { showSlider } = this.state;

    updateProcessLimit(total);
    return this.setState({ showSlider: !showSlider });
  }

  render() {
    const {
      id,
      total,
      winningModel,
      processLimit,
      defaultProcessLimit,
      processLimitPct,
      processTotal,
      frontier,
      trueAction,
      globalModel,
      options,
      targeted,
      isShow,
      timePeriod,
      updateProcessLimit,
      updateTimePeriod
    } = this.props;
    const { showSlider } = this.state;

    if (processLimit === undefined) {
      return <div />;
    }

    let marks = {};

    let start = frontier[Object.keys(frontier)[Object.keys(frontier).length - 1]];

    Object.keys(frontier)
      .reverse()
      .filter((fKey) => frontier[fKey])
      .forEach((fKey) => {
        if (frontier[fKey].id !== start.id) {
          marks[start.ratio * total] = "";
          marks[frontier[fKey].ratio * total] = "";
        }

        start = frontier[fKey];
      });

    marks[defaultProcessLimit] = {
      label: "ORG AVERAGE",
      style: { fontSize: "10px" }
    };

    return (
      <div className={styles.sliders + " " + styles.frontierSlider}>
        {showSlider && (
          <div style={{ width: "100%" }} id="processSlider">
            <div className={styles.explain}>
              <div className={processLimit < defaultProcessLimit ? styles.explainActive : ""}>
                <div>{"Don't Waste Effort"}</div>
                <div className={styles.smallFont}>{"AVOID UNCERTAIN DEALS"}</div>
              </div>
              <div className={processLimit > defaultProcessLimit ? styles.explainActive : ""}>
                <div>{"Don't Lose Deals"}</div>
                <div className={styles.smallFont}>{"WORK MORE OPPORTUNITIES"}</div>
              </div>
            </div>
            <SliderMini
              min={0}
              max={total}
              value={processLimit}
              frontier={frontier}
              inputType={"int"}
              onChange={(val) => updateProcessLimit(val)}
              className={styles.sliderHolderMini}
              endLabel={timePeriod ? "Transactions per " + timePeriod : "Transactions"}
              isWideLabel
              style={{ paddingTop: "0px" }}
              isMini
              marks={marks}
            />
          </div>
        )}
      </div>
    );
  }
}
